import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b42d61d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  class: "flex flex-col border-l-4 mr-2 mb-2 font-bold flex-wrap",
  style: {"border-color":"'#7fd6ff'"}
}
const _hoisted_3 = { class: "w-full py-2 px-4 flex flex-row items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-32 flex items-center text-lg" }, "時段", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Clear All")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Select All")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Loading records, please wait... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_n_select, {
            class: "py-1",
            value: _ctx.selectValue,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectValue) = $event)),
              _ctx.handleUpdateValue
            ],
            multiple: "",
            options: _ctx.options,
            clearable: "",
            filterable: "",
            placeholder: "Please Select Period"
          }, null, 8, ["value", "options", "onUpdate:value"])
        ])
      ])
    ]),
    _createVNode(_component_n_space, { class: "py-3 pb-5" }, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          type: "info",
          secondary: "",
          onClick: _ctx.onClearAll
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_n_button, {
          type: "info",
          onClick: _ctx.onSelectAll
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_DataTable, {
        value: _ctx.data,
        ref: "data_dt",
        dataKey: "EventParticipantId",
        loading: _ctx.loading,
        paginator: true,
        rows: 10,
        rowHover: true,
        resizableColumns: true,
        columnResizeMode: "fit",
        class: "p-datatable-sm",
        stripedRows: "",
        showGridlines: "",
        rowClass: _ctx.rowClass
      }, {
        loading: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "Name",
            header: "Name",
            sortable: true,
            style: {"width":"10rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.stockClass(slotProps.data))
              }, _toDisplayString(slotProps.data.Name), 3)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTime, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.EventScheduleId,
              header: _ctx.dataformat(col),
              key: col.EventScheduleId
            }, null, 8, ["field", "header"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "loading", "rowClass"])
    ])
  ], 64))
}